import {
  SessionDateAvailabilityDto,
  SessionDateAvailabilityRequest,
  IGetSessionDateAvailabilitiesCentreContextFromSessionDateAvailabilityServiceQuery,
  IGetSessionDateAvailabilitiesDistrictContextFromSessionDateAvailabilityServiceQuery,
  sessionDateAvailabilityClient,
} from 'api/planning';
import { api } from '../api';
import { LRW_SESSION_DATE_AVAILABILITIES_TAG } from 'store';
import { invalidateOn } from 'utils';

export const sessionDateAvailabilityApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSessionDateAvailabilitiesCentreContext: builder.query<
      SessionDateAvailabilityDto[],
      { year: number; month: number; centreId: number | undefined }
    >({
      query: ({ year, month, centreId: _centreId }) => {
        const query: IGetSessionDateAvailabilitiesCentreContextFromSessionDateAvailabilityServiceQuery =
          {
            year,
            month,
          };

        return sessionDateAvailabilityClient.getSessionDateAvailabilitiesCentreContext(query);
      },
      providesTags: () => [{ type: LRW_SESSION_DATE_AVAILABILITIES_TAG }],
    }),
    getSessionDateAvailabilitiesDistrictContext: builder.query<
      SessionDateAvailabilityDto,
      { year: number; month: number; locationId: number | undefined }
    >({
      query: ({ year, month, locationId: _locationId }) => {
        const query: IGetSessionDateAvailabilitiesDistrictContextFromSessionDateAvailabilityServiceQuery =
          {
            year,
            month,
          };

        return sessionDateAvailabilityClient.getSessionDateAvailabilitiesDistrictContext(query);
      },
      providesTags: () => [{ type: LRW_SESSION_DATE_AVAILABILITIES_TAG }],
    }),
    saveSessionDateAvailabilities: builder.mutation<void, SessionDateAvailabilityRequest>({
      query: (request) => sessionDateAvailabilityClient.saveSessionDateAvailabilities(request),
      invalidatesTags: invalidateOn({
        success: [LRW_SESSION_DATE_AVAILABILITIES_TAG]
      }),
    }),
  }),
});

export const {
  useGetSessionDateAvailabilitiesCentreContextQuery,
  useGetSessionDateAvailabilitiesDistrictContextQuery,
  useSaveSessionDateAvailabilitiesMutation,
} = sessionDateAvailabilityApi;
